import {
  isValidPriceFormat,
  IsIntegerPositive,
  IsIntegerNotNagtive,
  isValidWeightFormat,
  IsInteger,
  IsDecimal
} from '@/utils/validator'

const checker = {
  'price': {
    check(value) {
      const validPriceFormat = isValidPriceFormat(value);
      if (value && validPriceFormat) {
        return true;
      } else {
        return false;
      }
    },
    format(value) {
      // 如果值是string类型并且是空字符串，直接返回。否则的话转换成后面带两位小数
      if (typeof (value) == "string" && value == '') {
        return ''
      }
      if (!this.check(value)) {
        // return value;
        return '';
      }
      return parseFloat(value).toFixed(2)
    },
    replace(value) {
      return justNumberAndDot(value);
    },
    getHint() {
      return '金额格式有误，格式为[00000000.00]'
    }
  },
  // 非负正整数
  'positive-int': {
    check(value) {
      var isIntegerPositive = IsIntegerNotNagtive(value);
      if (value && isIntegerPositive) {
        return true;
      } else {
        return false;
      }
    },
    format(value) {
      // 如果值是string类型并且是空字符串，直接返回。否则的话转换成后面带三位小数
      if (typeof (value) == "string" && value == '') {
        return ''
      }
      return parseInt(value)

    },
    replace(value) {
      return justNumberAndDot(value);
    },
    getHint() {
      return '格式有误，请输入[正整数]'
    }
  },
  'weight': {
    check(value) {
      const validPriceFormat = isValidWeightFormat(value);
      if (value && !validPriceFormat) {
        return false;
      } else {
        return true;
      }
    },
    replace(value) {
      return justNumberAndDot(value);
    },
    format(value) {
      // 如果值是string类型并且是空字符串，直接返回。否则的话转换成后面带三位小数
      if (typeof (value) == "string" && value == '') {
        return ''
      }
      return parseFloat(value).toFixed(3)
    },
    getHint() {
      return '重量格式有误，格式为[0000.000]'
    }
  },
}

/**
 * 过滤掉除数字和小数点外的所有字符
 */
function justNumberAndDot(value) {
  var s = value.toString();
  s = s.replace(/[^\d.]/g, "");
  //必须保证第一个为数字而不是.
  s = s.replace(/^\./g, "");
  //保证只有出现一个.而没有多个.
  s = s.replace(/\.{2,}/g, ".");
  //保证.只出现一次，而不能出现两次以上
  s = s.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
  return s;
}

export function getChecker(type) {
  return checker[type]
}